<template>
  <Banner>
    <img src="../assets/img/banner-small.jpg" alt="contact-us" name="Contact Us" style="width: 100%;max-height: 550px">
  </Banner>
  <div class="product">
    <div class="side-bar">
      <header> <i class="iconfont icon-product_a" /> Product</header>
      <ul class="nav">
        <li class="nav-item" v-for="(item, index) in products" :key="index" ref="navItem">
          <div class="nav-item-wrapper">
            <nuxt-link :to="item.url" class="nav-item-title">
              {{ item.title }}
            </nuxt-link>
            <!--<i class="iconfont icon-jiantouxia"  @click="iconClick(index)"/>-->
          </div>
          <ul class="sub-nav">
            <li v-for="(p,i) in item.children" :key="i" class="sub-nav-item" v-show="!p.isShow">
              <nuxt-link :to="p.url" class="sub-nav-item-title">
                {{ p.title }}
              </nuxt-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="product-main">
      <nuxt-page />
    </div>
  </div>
</template>

<script setup lang="ts">
import {nav, products} from "~/data/data"
import {useRoute} from "vue-router"

useHead({
  title: 'product',
  meta: [{
    name: 'description',content: 'product description of RCH, includes Samsung,Philip,Lg,Aoc,Sony,Hair,Maya,Envision,Vizio and so on'
  }]
})
const route = useRoute()

onMounted(() => {
  init()
})
onUpdated(() => {
  init()
})
function init() {
  const fullPath = route.fullPath
  console.log(fullPath.indexOf('/product/detail/ag'))
  if(fullPath === '/product/smd-agriculture' || fullPath.indexOf('/product/detail/ag') != -1) {
    handleClick(12)
    return
  }
  if(fullPath === '/product/smd-automotive'|| fullPath.indexOf('/product/detail/auto') != -1) {
    handleClick(13)
    return
  }
  if(fullPath === '/product/smd-medical'|| fullPath.indexOf('/product/detail/med') != -1) {
    handleClick(14)
    return
  }
  if(fullPath === '/product/smd-industrial'|| fullPath.indexOf('/product/detail/ind') != -1) {
    handleClick(15)
    return
  }
  let pathPrefix = fullPath.split('-')[0]
  if (pathPrefix.indexOf('detail') != -1) {
    pathPrefix = pathPrefix.replace('/detail','')
  }
  const routeIndex = products.findIndex(item => item.url === pathPrefix)
  handleClick(routeIndex)
}


const navItem = ref()

function handleClick(index:number) {
  const navItems = navItem.value
  // 1. 遍历所有navItems,计算当前被点击的子菜单的长度，设置其长度
  for(let i = 0; i < navItems.length; i++) {
    const subNav = navItems[i].children[1];
    if(index === i) {
      // 点击的子菜单高度为0px或者第一次点击，height为undefined时，给子菜单设置高度
      if(subNav?.style.height === '0px' || !subNav?.style.height) {
        let subNavItemCount = subNav!.children.length
        if(index === 11) {
          subNavItemCount = 3
        }
        const realHeight = subNavItemCount * 35 + 'px'
        subNav!.setAttribute('style',`height: ${realHeight}`)
        navItems[i].children[0].children[0].style.color = '#1e8bac'
      }
    } else {
      // 2. 没有被点击的，将其子菜单高度设为0
      subNav!.setAttribute('style',`height: 0`)
      navItems[i].children[0].children[0].style.color = '#666'
    }
  }
}

function iconClick(index:number) {
  const product = document.querySelector('.product')
  const navItems = product!.querySelectorAll('.nav-item')
  // 1. 遍历所有navItems,计算当前被点击的子菜单的长度，设置其长度
  for(let i = 0; i < navItems.length; i++) {
    const subNav = navItems[i].querySelector('.sub-nav');

    if(index === i) {
      // 点击的子菜单高度为0px或者第一次点击，height为undefined时，给子菜单设置高度
      if(subNav?.style.height === '0px' || !subNav?.style.height) {
        const subNavItemCount = subNav!.children.length
        const realHeight = subNavItemCount * 35 + 'px'
        subNav!.setAttribute('style',`height: ${realHeight}`)
      } else {
        // 子菜单展开后，再次点击，将高度设置为0
        subNav!.setAttribute('style',`height: 0`)
      }
    } else {
      // 2. 没有被点击的，将其子菜单高度设为0
      subNav!.setAttribute('style',`height: 0`)
    }
  }
}
</script>

<style lang="stylus" scoped>
.product
  max-width 1510px
  min-width 1280px
  height 100%
  margin 40px auto
  padding 0 50px
  box-sizing border-box
  display flex
  .side-bar
    width 300px
    header
      background #077090
      opacity .8
      height 55px
      color #FFF
      text-align left
      line-height 55px
      font-size 30px
      font-weight 300
      padding 0 20px
      display flex
      align-items center
      &>i
        color #FFF
        font-size 22px
        margin-right 8px
    .nav
      border 1px solid #EEE
      border-bottom none
      &-item
        line-height 20px
        &:hover .nav-item-title
          color #1e8bac
        &-wrapper
          display flex
          align-items center
          border-bottom 1px solid #EEE
          justify-content space-between
          .router-link-active
            color: #1e8bac!important
          .nav-item-title
            display block
            padding 20px
            box-sizing border-box
            color #666
          .icon-jiantouxia
            margin-right 10px
            cursor pointer
        .sub-nav
          transition all .3s linear
          height 0
          overflow hidden
          background #f7f7f7
          &-item
            height 35px
            line-height 35px
            .sub-nav-item-title
              display inline-block
              padding-left 2em
              color #666
  .product-main
    flex 1
    margin-left 20px
</style>
